export const USAA = {
	SSO_INACTIVE: 'ssoinactive',
};
